import { locales } from '@americanexpress/conditional-features';

const getSafeIndexRedirectLocaleUtil = (unsafeLocale) => {
  let responseLocale = 'en-US';
  try {
    const matchingLocale = Object.values(locales).find(
      (locale) => locale.toLowerCase().includes(unsafeLocale.toLowerCase())
    );
    if (matchingLocale) {
      responseLocale = matchingLocale;
    }
    // eslint-disable-next-line no-empty -- just using try to cover multiple error cases
  } catch (e) {}
  return responseLocale;
};

export default getSafeIndexRedirectLocaleUtil;
